/**
 * 金额格式化。
 *
 * ★ 只此一份。原来收入页和结算页各写了一份,而**两份行为不一样**:
 *   收入页那份用 BigInt 除法和取余,碰到负数会输出 `MYR -1.-50`
 *   (-150n / 100n === -1n,-150n % 100n === -50n)。
 *
 *   收入页显示的是酬劳,不会是负数,所以一直没炸 —— 但结算调整项**会**
 *   是负数,而这两个页面挨在一起,谁顺手复用一下就出来了。
 *
 * ★ 用字符串而不是 Number:金额是最小货币单位的整数,可能超过 2^53。
 */
export function money(minor: string | number, currency = ''): string {
  const raw = typeof minor === 'number' ? String(Math.round(minor)) : minor;
  const neg = raw.startsWith('-');
  const digits = (neg ? raw.slice(1) : raw).padStart(3, '0');
  const text = `${digits.slice(0, -2)}.${digits.slice(-2)}`;
  return `${neg ? '-' : ''}${currency ? `${currency} ` : ''}${text}`;
}

/**
 * 「这一单要收多少」这一句话,四个地方都要说:
 * 抢单卡、新任务卡、在途卡、地图图钉,还有详情里那块红框。
 *
 * ★ 写成一个函数而不是在每处各写一遍三元判断 ——
 *   四份手写的判断迟早走歪,而走歪的形式是**某一处漏掉了待定的单**:
 *   那一处上面「代收」整行不出现,司机据此认为这单不用收钱。
 *
 * @returns null 表示这一单不用代收,那一行整个不该出现
 */
export function codLabel(
  codAmount: string | number | null | undefined,
  codPending: boolean | undefined,
  currency = '',
): string | null {
  if (codPending) return '金额待定';
  const n = Number(codAmount ?? 0);
  if (!(n > 0)) return null;
  return money(codAmount!, currency);
}
